<template>
<div class="chapter">
<div class="inner_page">
<h2 class="GFP_Halftitle" epub:type="bodymatter">beneficence</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?4b170b54